import menuItems, { IMenuItem } from "../menus";
import type { NextRouter } from "next/router";

export const getMenuItems = (Router: NextRouter) => {
  let isActiveMainMenu: boolean = false;
  let isActiveSubMenu: boolean = false;
  let selectedMainItem: IMenuItem | undefined = undefined;
  let selectedSubItem: IMenuItem | undefined = undefined;
  let selectedSubItems: IMenuItem[] | undefined = undefined;

  menuItems.map((item) => {
    let pathName = Router.asPath.split("?")[0];
    const parentPath = Router.asPath.split("?")[0].split("/")[1];

    let currentRoute = Router.route;
    if (parentPath === "board") {
      currentRoute = currentRoute.replace("[category]", Router.query.category as string);
    }

    if (item.href === pathName || (item.matches && item.matches.includes(currentRoute))) {
      isActiveMainMenu = true;
      isActiveSubMenu = false;
      selectedMainItem = item;
      selectedSubItems = [];
    } else {
      item.subItems &&
        item.subItems.map((subItem) => {
          if (subItem.href === pathName || (subItem.matches && subItem.matches.includes(currentRoute))) {
            selectedMainItem = item;
            selectedSubItem = subItem;
            selectedSubItems = item.subItems;
            isActiveMainMenu = false;
            isActiveSubMenu = true;
          }
        });
    }
  });

  return {
    isActiveMainMenu,
    isActiveSubMenu,
    selectedMainItem,
    selectedSubItem,
    selectedSubItems,
  };
};
